import styled, { css } from 'styled-components'
import { image } from '../../../styles'
import { ImageProps } from '../../../styles/types'
import { BaseImageProps } from '../ImageTypes'

const pointerEvents = css<ImageProps>`
    ${(props): string => (props.pointerEvents ? `pointer-events: ${props.pointerEvents}` : '')}
`
const resizeMode = css<ImageProps>`
    ${(props): string => `object-fit: ${props.resizeMode || 'cover'};`}
`

const blurRadius = css<ImageProps>`
    ${(props): string =>
        props.blurRadius
            ? `-webkit-filter: blur(${props.blurRadius}px); filter: blur(${props.blurRadius}px);`
            : ''}
`

const tintColor = css<ImageProps>`
    ${(props): string =>
        props.tintColor
            ? `filter: brightness(0)${props.tintColor === 'white' ? ' invert(1)' : ''};`
            : ''}
`

const BaseImage = styled.img<BaseImageProps>`
    ${image}
    ${blurRadius}
    ${resizeMode}
    ${tintColor}
    ${pointerEvents}
`

BaseImage.defaultProps = {
    width: '100%',
}

export default BaseImage
